import {Injectable} from '@angular/core';
import {ConfigurationService} from '~/app/core/common/services/configuration.service';
import { HttpClient } from '@angular/common/http';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {environment} from '~/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class ErrorApiService {

    testHTTPSPLUNK = environment.servicePrefix + `/testhttp/splunk`;
    testHTTP500 = environment.servicePrefix + `/testhttp/500`;
    testHTTP400 = environment.servicePrefix + `/testhttp/400`;
    testHTTP401 = environment.servicePrefix + `/testhttp/401`;
    testHTTP403 = environment.servicePrefix + `/testhttp/403`;
    testHTTP404 = environment.servicePrefix + `/testhttp/404`;

    constructor(private _configuration: ConfigurationService,
                public http: HttpClient,
                public httpClient: HttpClient,
                public applicationSettingsHelper: ApplicationSettingsHelper) {
    }

    test500() {
        return this.httpClient.get(
            this.testHTTP500)
            .toPromise()
            .then(response => response);
    }

    test400() {
        return this.httpClient.get(
            this.testHTTP400)
            .toPromise()
            .then(response => response);
    }

    test401() {
        return this.httpClient.get(
            this.testHTTP401)
            .toPromise()
            .then(response => response);
    }

    test403() {
        return this.httpClient.get(
            this.testHTTP403)
            .toPromise()
            .then(response => response);
    }

    test404() {
        return this.httpClient.get(
            this.testHTTP404)
            .toPromise()
            .then(response => response);
    }

    testSplunk() {
        return this.httpClient.get(
            this.testHTTPSPLUNK)
            .toPromise()
            .then(response => response);
    }
}
